import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const HeartIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        className="animate__animated animate__flipInY"
        stroke="currentColor"
        strokeWidth="1.5"
        d="M8.075 14.053l-.075.05a30.444 30.444 0 01-1.31-.935c-1.004-.758-2.28-1.815-3.397-3.024C2.166 8.924 1.258 7.61.907 6.34c-.336-1.216-.173-2.4.882-3.524.623-.66 1.26-.945 1.858-1.033.614-.09 1.238.019 1.822.23.583.21 1.094.51 1.465.764a6.86 6.86 0 01.534.405l.024.021.004.004h0L8 3.663l.503-.457h.001l.004-.004.024-.021.108-.09a6.86 6.86 0 01.426-.315c.37-.253.882-.554 1.465-.765.584-.21 1.208-.32 1.822-.23.598.089 1.235.374 1.858 1.034 1.055 1.125 1.218 2.308.882 3.524-.351 1.27-1.258 2.585-2.386 3.805-1.116 1.21-2.393 2.266-3.398 3.024-.5.378-.93.679-1.234.885z"
      />
    </SvgIcon>
  );
};
